import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
    SearchSymbolRequest,
    SearchSymbolResponse,
    AddSpecificSymbolResponse,
    AddSpecificSymbolParams
} from '../../../../../app.interfaces';
import { applicationUrls } from 'sharedweb/helpers/urls';
import { of } from 'rxjs';
import { SearchSymbolResults } from 'sharedweb/app.interface';

@Injectable({
    providedIn: 'root'
})
export class AddSymbolService {
    symbolsearch = new Map<String, SearchSymbolResults[]>();

    constructor(private _httpClient: HttpClient) { }

    getSymbolSearchData(symbolSearchRequest: SearchSymbolRequest) {
        const url = applicationUrls.searchSymbolUrl;
        const newSymbolKey = symbolSearchRequest.security_id + "_" + symbolSearchRequest.market_id;

        if (this.symbolsearch.has(newSymbolKey)) {
            return of(this.symbolsearch.get(newSymbolKey));
        }
        else {
            return this._httpClient.get<SearchSymbolResponse>(url, {
                params: <any>symbolSearchRequest
            }).map(res => {
                if (res.data?.length) {
                    const key = res.data[0]['security_id'] + '_' + res.data[0]['market_id'];
                    this.symbolsearch.set(key, res.data)
                    return this.symbolsearch.get(key);
                }
                return null;
            });
        }
    }

    getSpecificSymbolSearchData(specificSymbolSearchParams: AddSpecificSymbolParams) {
        const url = applicationUrls.searchSpecificSymbolUrl;
        return this._httpClient.get<AddSpecificSymbolResponse>(url, {
            params: <any>specificSymbolSearchParams
        });
    }

}
